import { ref, get, set } from "firebase/database";
import { dataHolder } from "./dataHolder";

/**
 * Get today's availability
 * @returns {Promise<Object|null>}
 */
export const getAvailability = async () => {
  try {
    const dbRef = ref(dataHolder.db, "availability");
    const snapshot = await get(dbRef);

    if (snapshot.exists()) {
      console.log("Data:", snapshot.val());
      return snapshot.val();
    } else {
      console.log("No data available");
      return null;
    }
  } catch (e) {
    console.log("Error fetching availability:", e);
    return null;
  }
};

/**
 * Save availability
 * @param {Object} data - { doctors: [...], isHoliday: boolean }
 * @returns {Promise<boolean>}
 */
export const saveAvailability = async (data) => {
  try {
    const dbRef = ref(dataHolder.db, "availability");
    await set(dbRef, data);
    console.log("Availability saved");
    return true;
  } catch (e) {
    console.log("Error saving availability:", e);
    return false;
  }
};
